var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLayout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.877 14.201c.275 0 .504.036.648.181.146.148.181.384.181.67v2.257c0 .286-.035.522-.181.67-.144.146-.373.181-.648.181H5.142c-.274 0-.5-.038-.646-.183-.148-.148-.183-.383-.183-.668v-2.256c0-.285.035-.521.183-.669.145-.145.372-.183.646-.183zm9.009-6.518c.272 0 .498.034.64.18.145.15.182.386.182.671v7.83c0 .287-.035.524-.18.673-.142.144-.369.178-.642.178h-4.739c-.275 0-.504-.035-.648-.18-.146-.149-.182-.385-.182-.671v-7.83c0-.284.038-.52.184-.669.144-.146.372-.182.646-.182zM10.079 6.65c.272 0 .499.036.642.18.146.145.18.38.18.664v3.157c0 .286-.035.522-.182.67-.143.145-.369.181-.64.181H3.472c-.271 0-.497-.036-.64-.18-.147-.149-.182-.385-.182-.671V7.494c0-.284.034-.519.18-.665.143-.143.37-.179.642-.179z",
    stroke: "#FFF",
    strokeWidth: 1.3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayout);
export default __webpack_public_path__ + "static/media/layout.79bad861.svg";
export { ForwardRef as ReactComponent };